// DeviceSelector.js

import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { useSetRecoilState } from 'recoil';

import { audioDeviceIdState, videoDeviceIdState } from './../../common/recoil/Cameras/atom';

const DeviceSelector = ({ onSelectAudioDevice, onSelectVideoDevice }) => {
    const [audioDevices, setAudioDevices] = useState([]);
    const [videoDevices, setVideoDevices] = useState([]);
    const setAudioDeviceId = useSetRecoilState(audioDeviceIdState);
    const setVideoDeviceId = useSetRecoilState(videoDeviceIdState);

    useEffect(() => {
        const getAvailableDevices = async () => {
            try {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const audioDevices = devices.filter(device => device.kind === 'audioinput');
                const videoDevices = devices.filter(device => device.kind === 'videoinput');
                setAudioDevices(audioDevices);
                setVideoDevices(videoDevices);
            } catch (error) {
                console.error('Error enumerating devices:', error);
            }
        };

        getAvailableDevices();
    }, []);

    const handleAudioDeviceChange = (event) => {
        const deviceId = event.target.value;
        setAudioDeviceId(deviceId);
    };

    const handleVideoDeviceChange = (event) => {
        const deviceId = event.target.value;
        setVideoDeviceId(deviceId);
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            <FormControl style={{ minWidth: '200px', marginBottom: '20px' }}>
                <InputLabel>Select Audio Device</InputLabel>
                <Select onChange={handleAudioDeviceChange}>
                    {audioDevices.map(device => (
                        <MenuItem key={device.deviceId} value={device.deviceId}>
                            {device.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl style={{ minWidth: '200px' }}>
                <InputLabel>Select Video Device</InputLabel>
                <Select onChange={handleVideoDeviceChange}>
                    {videoDevices.map(device => (
                        <MenuItem key={device.deviceId} value={device.deviceId}>
                            {device.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default DeviceSelector;
